import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ProductCard from "@/components/ProductCard";
import Marquee from "@/components/Marquee";
import { Reveal } from "@/components/motion";

export default function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  const kits = products.filter((p) => p.category === "kit");
  const accessories = products.filter((p) => p.category === "accessory");

  return (
    <div data-testid="products-page">
      <PageHeader
        kicker="Kits & Hardware"
        title="The full Banner Bar lineup"
        sub="Every kit ships with the telescoping bar, T-clips, sized bungees and UV post covers. T-posts are sourced locally — under $10 each at any farm & ranch store."
        image="/assets/img/w-gallery-img-5061.jpg"
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        {loading ? (
          <p className="font-mono text-sm uppercase tracking-widest text-slate-500" data-testid="products-loading">Loading hardware...</p>
        ) : (
          <>
            <Reveal><p className="font-mono text-xs uppercase tracking-[0.3em] text-hivis">Frame Kits</p></Reveal>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="kits-grid">
              {kits.map((p, i) => <ProductCard key={p.slug} product={p} i={i} />)}
            </div>
            <Reveal className="mt-20"><p className="font-mono text-xs uppercase tracking-[0.3em] text-hivis">Parts & Accessories</p></Reveal>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="accessories-grid">
              {accessories.map((p, i) => <ProductCard key={p.slug} product={p} i={i} />)}
            </div>
          </>
        )}
      </section>
      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-12" data-testid="products-help-section">
        <Reveal>
          <div className="clip-corner flex flex-col items-start gap-6 border border-girder bg-steel/50 p-8 sm:flex-row sm:items-center sm:justify-between" data-testid="products-help-band">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-hivis">Not Sure Which Kit?</p>
              <h3 className="mt-2 font-display text-3xl font-black uppercase text-slate-100">Measure the space, we'll match the frame</h3>
              <p className="mt-2 max-w-xl text-sm text-slate-400">Compare all four kits side by side, or call 970-650-5173 and we'll size it with you in five minutes.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to="/compare" data-testid="products-compare-cta" className="clip-corner-sm bg-hivis px-6 py-3 font-display font-bold uppercase text-obsidian transition-colors hover:bg-hivis-hover">Compare kits</Link>
              <a href="tel:9706505173" data-testid="products-call-cta" className="clip-line-sm px-6 py-3 font-display font-bold uppercase text-slate-200 transition-colors hover:text-hivis hover:[--cb-line:#F59E0B]">Call us</a>
            </div>
          </div>
        </Reveal>
      </section>
      <Marquee />
    </div>
  );
}
